import React from "react";
import { JSInputComponent, JSInputProps } from "../JamezzStylesCSSInput";
import FormSelect from "../../../../../../components/Forms/FormSelect";
import FormText from "../../../../../../components/Forms/FormText";
import { MenuItem } from "@mui/material";

function FontSize({ name, required }: JSInputProps) {
  return (
    <FormSelect
      name={name}
      options={[
        <MenuItem key={""} value={""}>
          Default
        </MenuItem>,
        [0.5, 0.75, 1, 1.1, 1.2, 1.3, 1.4, 1.5, 1.6, 1.7, 1.8, 1.9, 2, 2.25, 2.5, 3.5, 4, 4.5, 5, 5.5, 6, 6.5, 7].map(
          (size) => {
            return (
              <MenuItem key={size} value={`${size}rem`}>
                <span style={{ fontSize: `${size}rem` }}>{size}rem</span>
              </MenuItem>
            );
          }
        ),
      ]}
      rules={{ required }}
    />
  );
}

export const JSFontSizeComponent: JSInputComponent = {
  Component: FontSize,
  handlesCssProperties: ["fontSize"],
};
